/**
 * Created by artyom.grishanov on 28.12.15.
 */
import {
    getConfig,
    getScreenGroup,
    getPropertyControlConfig,
    needShowScreenControl,
} from '../../utils/productConfig.js'
import HashList from '../../utils/hashlist.js'
import {
    setup,
    setProjectName,
    setProjectJson,
    save,
    publish,
    getEmbedCode,
    // getLink,
    getProject,
    setProjectPreviewImage,
    getTemplate,
    createShareEntities,
    setProjectTitle,
    setProjectDescription,
    setProjectImage,
    setProjectCustomImageSelected,
    getText,
    encodeAllHtmlStringsInObject,
} from '../../utils/publisher'

import store from '../../store'
import {
    EDITOR__UPDATE_SCREENS,
    EDITOR__UPDATE_ACTIVE_SCREEN_ID,
    EDITOR__UPDATE_ACTIVE_POPUP_ID,
    EDITOR__SHOW_POPUP,
    EDITOR__HIDE_POPUP,
    EDITOR__SET_PROJECT_TYPE_DATA,
    EDITOR__SET_PROJECT_TYPE,
    EDITOR__ENABLE_POPUPS,
    EDITOR__DISABLE_POPUPS,
} from '../../store/actions/editor'

import { BASE_URL } from '../../api/instance/servers/main'

import { getPreview } from './PreviewMaker'

window.Editor = {}
;(function (global) {
    let getUniqId = window.getUniqId,
        $ = window.$,
        Workspace = window.Workspace,
        ControlManager = window.ControlManager,
        AssistentPopup = window.AssistentPopup,
        ResourceManager = window.ResourceManager,
        App = window.App,
        directiveLoader = window.directiveLoader,
        getQueryParams = window.getQueryParams,
        config = window.config,
        RemixContainer = window.RemixContainer,
        log = window.log,
        Auth = window.Auth,
        ScreenManager = window.ScreenManager,
        isNumeric = window.isNumeric,
        SelectDialog = window.SelectDialog,
        PublishDialog = window.PublishDialog
    /**
     * Переменная true если идет процесс сохранения через функцию saveProject
     * @type {Boolean}
     */
    let saving_process = false

    /**
     * Приложение MutApp которое редактируется в редакторе
     * @type {MutApp}
     */
    let editedApp = null
    /**
     * Уникальный ид проекта
     * Также это имя файла, которое будет использовано при сохранении
     * @type {string}
     */
    let projectId = null
    /**
     * Уникальный ид проекта созданный на бекенде
     * @type {string}
     */
    let numberId = null
    /**
     * Строковый идентификатор открытого проекта: test, timeline и тд
     * @type {string}
     */
    let projectTypeId = null
    /**
     * Кастомный идентификатор типа открытого проекта: TRIVIA, PHOTOSTORY и тд
     * @type {string}
     */
    let projectTypeCustomId = null
    /**
     * Конфиг активного типа проекта
     * @type {string}
     */
    let projectTypeConfig = null
    /**
     * Ссылки на файлы типа проекта и projectJson
     */
    let projectTypeData = {}
    /**
     * конверсионные типы событий
     */
    let projectActions = []
    /**
     *
     */
    let projectForms = []
    let sharingLinkRedirectUrl = null
    /**
     * Последняя версия типа проекта projectType
     * TODO подумать - всегда ли мы используем именно последнюю версию? или версию как мы замораживается при создании проекта?
     */
    let currentVersionId = null
    /**
     * текущий шаблон, который открыт. Шаблона может не быть, тогда используются свойства из кода проекта
     * @type {object} {projectTypeId: <string>, app: <object>, descriptor: <object>}
     */
    var appTemplate = null
    /**
     * Сериализованные свойства приложения.
     * При старте получаем из шаблона или из localStorage
     *
     * @type {string}
     */
    var serializedProperties = null
    /**
     * Картинка для проекта, которая была загружена во время сессии
     * Если ничего нового не было загружено, то null
     * @type {string}
     */
    var sessionPreviewUrl = null
    /**
     * Диалог с выбором ресурсов (картинки). Можно зааплоадить, запросить список с сервера и выбрать картинку
     * @type {object}
     */
    var resourceManager = null
    /**
     * Ид экрана который показан в данный момент в рабочем поле
     * @type {string}
     */
    var activeScreen = null
    /**
     * Все зарегистрированные DOM элементы с атрибутами data-app-property,
     * которые есть на всех activeScreens
     *
     * @type {Array}
     */
    var registeredElements = []
    /**
     * Строка data-app-property соответствующие элементы которой выделены на activeScreens
     * @type {string}
     */
    var selectedDataAppProperty = null
    /**
     * Подсказки для текущего экрана продукта
     * @type {Array}
     */
    var activeScreenHints = []
    /**
     * При показе экрана инициализируется набор триггеров.
     * В массиве собраны триггеры, активные на данный момент.
     * Триггеры могут быть в нескольких состояниях.
     *
     * @type {Array}
     */
    var activeTriggers = []
    /**
     * У автосейвера свой счетчик операций, он его обновляет по таймеру во время сохранения
     * Если editedApp.getOperationsCount() больше чем operationCountForAutosaver то надо сделать автосохранение
     *
     * @type {number}
     */
    var operationCountForAutosaver = 0
    /**
     * Признак того, что вошли в редактор с указанием клонировать проект
     * @type {boolean}
     */
    var cloneTemplate = false

    var activePublisher = null
    /**
     * Информация о выделенном элементе (элементах) в приложении
     */
    let selectedData = null
    /**
     * Ссылка на стили открытого типа проекта
     */
    let appCssUrl = null
    /**
     *
     */
    let callEditorTopbar = null
    let callEditorTab = null
    let callEditor = null
    let autoSaveInterval = null
    /**
     * Сохраненные html строки для отрисованных экранов приложения.
     */
    let screensRenderedHtmls = {}
    /**
     * Можно локально подменить ссылки и подгрузить с локалхоста проект для разработки
     */
    const LOCAL_OVERRIDE_TYPES = {
        // // common
        // commonjs: `http://127.0.0.1:8080/remix.js`,
        //
        // // except article
        // html: `http://127.0.0.1:8080/index.html`,
        // css: `http://127.0.0.1:8080/remix.css`,
        // script: `http://127.0.0.1:8080/personality.js`,
        //
        // // article
        // html: `http://127.0.0.1:8090/typeFiles/main.html`,
        // css: `http://127.0.0.1:8090/typeFiles/main.css`,
        // script: `http://127.0.0.1:8090/typeFiles/main.js`,
    }
    /**
     * Отступ области редактирования remix от ТОП бара.
     */
    let createdControls = {}
    /**
     * Тип отображения в редакторе ( desktop/mobile )
     * по дефолту desktop
     */
    let previewMode = 'desktop'

    /**
     * Функция запуска редактора
     */
    async function start() {
        getUniqId = window.getUniqId
        $ = window.$
        Workspace = window.Workspace
        ControlManager = window.ControlManager
        AssistentPopup = window.AssistentPopup
        ResourceManager = window.ResourceManager
        App = window.App
        directiveLoader = window.directiveLoader
        getQueryParams = window.getQueryParams
        config = window.config
        RemixContainer = window.RemixContainer
        log = window.log
        Auth = window.Auth
        ScreenManager = window.ScreenManager
        isNumeric = window.isNumeric
        SelectDialog = window.SelectDialog
        PublishDialog = window.PublishDialog

        callEditor({
            method: 'react-project-load-start',
        })

        appTemplate = null
        projectTypeId = null
        projectTypeCustomId = null

        projectTypeConfig = null

        Workspace.init({
            onWorkspaceEvents: onWorkspaceEvents,
        })
        ControlManager.init({
            onControlEvents: onControlEvents,
        })
        resourceManager = new ResourceManager()
        window.onbeforeunload = confirmExit
        window.onkeydown = onKeyDown

        $('#id-screen_controls_cnt').hide()

        $('#id-expert_mode').change(function () {
            const isExpert = $(this).prop('checked')
            ControlManager.setExpertMode(isExpert)
            Workspace.selectElementOnAppScreen(null)
            if (callEditorTab) {
                if (isExpert) {
                    callEditorTab({
                        method: 'open_components_panel',
                        callback: elem => {
                            const items = []

                            if (Array.isArray(elem)) {
                                for (let item of elem) {
                                    const realElementCenter = {
                                        // x: elem.width / 2,
                                        y: item.height / 2,
                                    }
                                    // item.top = item.top
                                    item.top = item.centerY - realElementCenter.y
                                    delete item.centerX
                                    delete item.centerY

                                    items.push(item)
                                }
                            } else {
                                const realElementCenter = {
                                    x: elem.width / 2,
                                    y: elem.height / 2,
                                }

                                elem.left = elem.centerX - realElementCenter.x
                                elem.top = elem.centerY - realElementCenter.y
                                delete elem.centerX
                                delete elem.centerY

                                items.push(elem)
                            }

                            items.forEach(component => {
                                if (store.getState().editor.showPopup) {
                                    editedApp.addHashlistElement(
                                        `router.screens.${activeScreen}.popups.${
                                            store.getState().editor.activePopupId
                                        }.components`,
                                        void 0,
                                        component,
                                    )
                                } else {
                                    editedApp.addHashlistElement(
                                        'router.screens.' + activeScreen + '.components',
                                        void 0,
                                        component,
                                    )
                                }
                            })
                        },
                        // callback: elementData => {
                        //     editedApp.getAppBoundingClientRect(rect => {
                        //         const data = Array.isArray(elementData) ? elementData : [elementData]
                        //
                        //         for (const datum of data) {
                        //             if (datum.left === void 0 && datum.top === void 0) {
                        //                 if (elementData.x !== void 0 && elementData.y !== void 0) {
                        //                     elementData.top = elementData.y - rect.y - 50
                        //                     elementData.left = elementData.x - rect.x + 20
                        //                     delete elementData.x
                        //                     delete elementData.y
                        //                 } else {
                        //                     elementData.left = (rect.width - (elementData.width || 0)) / 2
                        //                     elementData.top = (rect.height - (elementData.height || 0)) / 2
                        //                 }
                        //             }
                        //
                        //             if (store.getState().editor.showPopup) {
                        //                 editedApp.addHashlistElement(
                        //                     `router.screens.${activeScreen}.popups.${
                        //                         store.getState().editor.activePopupId
                        //                     }.components`,
                        //                     void 0,
                        //                     datum,
                        //                 )
                        //             } else {
                        //                 editedApp.addHashlistElement(
                        //                     'router.screens.' + activeScreen + '.components',
                        //                     void 0,
                        //                     datum,
                        //                 )
                        //             }
                        //         }
                        //     })
                        // },
                        data: {
                            components: projectTypeConfig.components,
                            // dropArea: {
                            //     x: 551.5,
                            //     y: 41,
                            //     width: 800,
                            //     height: 600,
                            //     top: 41,
                            //     right: 1351.5,
                            //     bottom: 641,
                            //     left: 551.5,
                            // },
                        },
                    })
                    $('#editor-side-panel__right').addClass('expert-panel-active')
                } else {
                    callEditorTab({
                        method: 'close_components_panel',
                        callback: () => {},
                    })
                    $('#editor-side-panel__right').removeClass('expert-panel-active')
                }
            }
        })

        $('#editor-side-panel__right #id-static_controls_cnt .list').scroll(function () {
            const scroll = $('#editor-side-panel__right #id-static_controls_cnt .list').scrollTop()
            const $expertPanel = $('#editor-side-panel__right #id-static_controls_cnt .control_cnt_wr.expert-style')
            if (scroll > 0) {
                $expertPanel.addClass('sticky')
            } else {
                $expertPanel.removeClass('sticky')
            }
        })

        directiveLoader.load(async function () {
            // сначала смотрим, есть ли ссылка на шаблон
            var templId = getQueryParams(document.location.search)[config.common.templateIdParamName],
                projId = getQueryParams(document.location.search)[config.common.projectIdParamName],
                numId = getQueryParams(document.location.search)[config.common.projectNumberIdParamName]

            if (templId) {
                try {
                    //projectId, numberId will be generatred in first saving process
                    const templateResp = await getTemplate(templId)
                    await loadApp(templateResp.projectType, templateResp.projectStructureJson)
                    restartEditedApp()
                    callEditor({
                        method: 'react-project-loaded--template',
                        data: templateResp,
                    })
                } catch (err) {
                    console.error(err)
                    callEditor({
                        method: 'react-project-load-error',
                        data: err,
                    })
                }
            } else if (projId && numId) {
                try {
                    // open existing project
                    projectId = projId
                    numberId = numId
                    //TODO add clone logic
                    cloneTemplate = getQueryParams(document.location.search)[config.common.cloneParamName] !== undefined
                    const projectResp = await getProject(projectId)
                    await loadApp(
                        projectResp.projectType,
                        projectResp.projectStructureJson,
                        projectResp.projectActions,
                        projectResp.projectForms,
                        projectResp.sharingLinkRedirectUrl,
                    )
                    restartEditedApp()
                    callEditor({
                        method: 'react-project-loaded--project',
                        data: projectResp,
                    })
                } catch (err) {
                    console.error(err)
                    callEditor({
                        method: 'react-project-load-error',
                        data: err,
                    })
                }
            } else {
                callEditor({
                    method: 'react-project-load-error',
                    data: null,
                })
            }
        })
        autoSaveInterval = setInterval(autoSaverTick, config.editor.ui.autoSaverTimerInterval)

        store.subscribe(
            (() => {
                // let prevActivePopupId = void 0

                return () => {
                    const { showPopup, activePopupId, mounted } = store.getState().editor

                    if (mounted) {
                        if (editedApp && editedApp.iframe.contentWindow) {
                            editedApp.setData({
                                'router.activePopupId': activePopupId,
                                'router.showPopup': showPopup,
                            })
                        }

                        // if (showPopup && activePopupId !== prevActivePopupId) {
                        if (showPopup && activePopupId) {
                            ControlManager.filter({ popupId: activePopupId })
                        }

                        if (showPopup) {
                            $('#editor-side-panel__left').hide()
                            $('#editor-popup-nav').show()
                            if (callEditorTab) callEditorTab({ method: 'show_popup_nav' })
                        } else {
                            $('#editor-popup-nav').hide()
                            $('#editor-side-panel__left').show()
                            if (callEditorTab) callEditorTab({ method: 'hide_popup_nav' })
                        }

                        // prevActivePopupId = activePopupId
                    } else {
                        if (showPopup) {
                            store.dispatch(EDITOR__HIDE_POPUP())
                        }
                    }
                }
            })(),
        )
    }

    /**
     * Загрузить тип проекта и данные в RemixContainer
     */
    async function loadApp(
        projectType,
        projectStructureJson,
        _projectActions = [],
        _projectForms = [],
        _sharingLinkRedirectUrl = null,
    ) {
        projectTypeCustomId = projectType.customId
        projectTypeConfig = getConfig(projectTypeCustomId)

        projectTypeId = projectType.id
        currentVersionId = projectType.currentVersionId
        projectActions = _projectActions
        projectForms = _projectForms
        sharingLinkRedirectUrl = _sharingLinkRedirectUrl
        const files = projectType.currentTemplate.files
        const commonJs = files.find(f => f.templateFileType === 'APP_JS' && f.name === 'common.js')
        projectTypeData = {
            script: files.find(f => f.templateFileType === 'APP_JS' && f.name === 'app.js').fileUrl,
            html: files.find(f => f.templateFileType === 'INDEX_HTML').fileUrl,
            css: files.find(f => f.templateFileType === 'STYLE_CSS').fileUrl,
            commonjs: commonJs ? commonJs.fileUrl : null,
            projectStructureJson,
        }
        if (LOCAL_OVERRIDE_TYPES) {
            // just for local development
            projectTypeData = { ...projectTypeData, ...LOCAL_OVERRIDE_TYPES }
        }
        appCssUrl = projectTypeData.css

        store.dispatch(EDITOR__SET_PROJECT_TYPE(projectType))
        store.dispatch(EDITOR__SET_PROJECT_TYPE_DATA(projectTypeData))
    }

    /**
     * Запустить редактируемое приложение
     */
    function restartEditedApp() {
        editedApp = new RemixContainer({
            mode: 'edit',
            element: document.getElementById('id-product_iframe_cnt'),
            noRender: getConfig(projectTypeCustomId).isBlockEditor ? true : false,
            url: projectTypeData.html,
            scriptUrl: projectTypeData.script,
            cssUrl: projectTypeData.css,
            commonjsUrl: projectTypeData.commonjs,
            width: 800,
            height: 600,
            marginTop: needShowScreenControl(projectTypeCustomId) ? 20 : 80,
            marginBottom: 20,
            containerLog: true,
            defaults:
                typeof projectTypeData.projectStructureJson === 'string'
                    ? projectTypeData.projectStructureJson
                    : JSON.stringify(projectTypeData.projectStructureJson),
            onEvent: onAppChanged,
        })
    }

    /**
     * Изменение превью вида в редакторе
     */
    const CHANGE_EDITOR_MIN_DELAY = 1000
    let canChangeEditorMode = true
    function changePreviewMode(mode = 'desktop') {
        if (canChangeEditorMode) {
            if (mode === 'mobile') {
                editedApp.setSize({ width: 320, height: 600 })
                previewMode = 'mobile'
            } else {
                editedApp.setSize({ width: 800, height: 600 })
                previewMode = 'desktop'
            }
            editedApp.setData({ 'app.screen': previewMode })
            canChangeEditorMode = false
            setTimeout(() => (canChangeEditorMode = true), CHANGE_EDITOR_MIN_DELAY)
            return true
        } else {
            return false
        }
    }

    /**
     * Попробовать установить ссылку для шаринга автоматически
     * По умолчанию в mutapp стоит ссылка на testix.me при шаринге
     * Если это так, то сменяем на ссылку этого проекта, например "http://p.testix.me/121947341568004/da3b379c56"
     * Если же проект былл клонирован, или открыт с витрины, то тоже надо сменить
     *
     * @param {boolean} forceChange сменить в любом случае (с витрины или клонирование)
     */
    function trySetDefaultShareLink(forceChange) {
        // var pp = editedApp.getProperty('appConstructor=mutapp shareLink');
        // if (pp) {
        //     if (forceChange === true || pp.getValue() == config.common.defaultShareLinkToChange) {
        //         pp.setValue(Publisher.getAnonymLink(projectId));
        //     }
        // }
        // else {
        //     log('setDefaultShareLink: can not find shareLink property', true);
        // }
    }

    /**
     * Поднять версию приложения на единицу
     *
     * @param {boolean} setZero
     */
    function bumpAppVersion(setZero) {
        var pp = editedApp.getProperty('appConstructor=mutapp publishVersion')
        if (pp) {
            if (setZero === true) {
                pp.setValue(0)
            } else {
                pp.setValue(parseInt(pp.getValue()) + 1)
            }
        } else {
            log('Editor.bumpAppVersion: can not find publishVersion property', true)
        }
    }

    /**
     * Предупреждение случайный закрытий страницы без сохранения
     * @returns {string}
     */
    function confirmExit() {
        if (editedApp && editedApp.getOperationsCount() > operationCountForAutosaver) {
            return 'You have unsaved changes, please click "Save & Exit"'
        }
    }

    function onKeyDown(e) {
        if (e.metaKey || e.ctrlKey) {
            const k = String.fromCharCode(e.keyCode)
            if (e.shiftKey && k === 'Z') {
                editedApp.redo()
            } else if (k === 'Z') {
                editedApp.undo()
            }
        }
    }

    /**
     * Вызывается раз в несколько секунд
     * Проверяет, если есть несохраненные операции, то делает сериализацию editedApp в localStorage
     */
    async function autoSaverTick() {
        if (!saving_process) {
            callEditor({
                method: 'react-autosave-project-start',
            })
            if (editedApp && editedApp.getOperationsCount() > operationCountForAutosaver) {
                console.log(
                    `Autosave: current operations ${editedApp.getOperationsCount()} > than prev ${operationCountForAutosaver}`,
                )
                try {
                    await saveProject()
                    operationCountForAutosaver = editedApp.getOperationsCount()
                } catch (e) {
                    console.error('Editor.autoSaverTick: Could not save app state. Details: ' + e.message)
                }
            }
            callEditor({
                method: 'react-autosave-project-end',
            })
        }
    }

    /**
     * Проверить локально в localStorage, есть ли несохраненное состояние у шаблона
     *
     * @param {string} templateUrl - ссылка на шаблон (это может быть витринный шаблон или пользовательский)
     * @return {boolean}
     */
    // function templateHasUnsavedLocalStorageState(templateUrl) {
    //     return window.localStorage.getItem('status__'+templateUrl) === 'unsaved' && !!window.localStorage.getItem(templateUrl);
    // }

    /**
     * iFrame промо проекта был загружен. Получаем из него document и window
     */
    function onProductIframeLoaded() {
        // скрыть контролы экранов для некоторых проектов. Например для панорам они не нужны
        if (projectTypeId && projectTypeConfig.hideScreenControls === true) {
            $('#id-screen_controls_cnt').hide()
        }

        if (config.common.editorUiEnable === true) {
            showEditor()

            // для установки ссылки шаринга требуются данные пользователя, ответ от апи возможно надо подождать
            if (cloneTemplate) {
                // при клонировании сменить ссылку на проект и версию публикаиции обнулить
                trySetDefaultShareLink(true)
                bumpAppVersion(true)
            }

            setTariffPolicy()

            callEditor({
                method: 'react-project-load-end',
            })
            callEditorTopbar({
                method: 'react-project-load-end',
            })
        }

        // в начале работы редактора запоминаем начальное количество операций/действий
        // затем, если оно будет увеличено, будем определять несохраненные изменения
        operationCountForAutosaver = editedApp.getOperationsCount()
        operationCountForAutosaver = editedApp.getOperationsCount()
    }

    /**
     * Применение политик тарифа к текущему пользователю
     */
    function setTariffPolicy() {
        // if (Auth.isTariff('basic') === true) {
        //     updateProductPageBackgroungImage();
        // }
        // else {
        //     var cntr = ControlManager.getControls({propertyString:'appConstructor=mutapp projectPageBackgroundImageUrl'})[0];
        //     if (cntr) {
        //         cntr.disable();
        //     }
        //     else {
        //         console.error('Editor.setTariffPolicy: Control not created yet for \'appConstructor=mutapp projectPageBackgroundImageUrl\'');
        //     }
        // }
    }

    /**
     * Создать ссылки на объекты шаринга /projects/{project_id}/share
     * Получить новые идишники
     * Сохранить в приложении
     */
    async function createShareEndpoints() {
        return new Promise((resolve, reject) => {
            // Запросить объекты для шаринга, которые есть в приложении
            editedApp.getShareEntities(async share => {
                try {
                    const triplets = Object.keys(share.entities).map(id => {
                        return {
                            title: share.entities[id].title,
                            description: share.entities[id].description,
                            imageId: share.entities[id].imageId,
                        }
                    })
                    const resp = await createShareEntities(triplets)
                    // Пример ответа
                    // [
                    //     {
                    //         "id": 934006, // sharing_id
                    //         "title": "Some title",
                    //         "description": "Some description",
                    //         "active": true,
                    //         "imageId": null,
                    //         "imageUrl": null
                    //     }
                    // ]
                    resp.forEach(r => {
                        if (!r.imageId) {
                            r.imageId = ''
                        } else {
                            r.imageId = r.imageId.toString()
                        }
                    })
                    resp.filter(r => r.active).forEach(r => {
                        const entities = Object.values(share.entities).filter(
                            ent =>
                                ent.title === r.title && ent.description === r.description && ent.imageId === r.imageId,
                        )
                        if (entities && entities.length > 0) {
                            // в теории может быть несколько шарингов с одинаковыми текстами и картинками
                            entities.forEach(e => (e.href = `${window.location.origin}/${numberId}/share/${r.id}.html`))
                        } else {
                            console.error(
                                `Sharing entity received from API with title="${r.title}" description="${r.description}" imageId="${r.imageId}" not found in app`,
                            )
                        }
                    })

                    // создать ссылки и сохранить их в приложение, пример
                    // http://dev.interacty.me/{project_id}/share/{sharing_id}.html
                    editedApp.setShareEntities(share)
                    resolve(resp)
                } catch (err) {
                    reject(err)
                }
            })
        })
    }

    /**
     * Сохранение проекта над которым работает пользователь
     */
    async function saveProject() {
        saving_process = true

        setup({
            apiServer: BASE_URL,
            projectId,
            numberId,
            currentVersionId,
            projectTypeId,
            projectActions,
            projectForms,
            sharingLinkRedirectUrl,
        })
        return new Promise((resolve, reject) => {
            // Запросить сериализацию стейта у приложения. Обмен происходит асинхронно через postMessage. Используется обычный колбек.
            editedApp.serialize(async state => {
                try {
                    setProjectJson(state)

                    setProjectName($('#react-project-name-input').val())
                    setProjectTitle($('#react-project-title-input').val())
                    setProjectDescription($('#react-project-description-input').val())
                    setProjectImage($('#react-project-image_id-input').val(), $('#react-project-image_url-input').val())
                    setProjectCustomImageSelected($('#react-project-custom_image-input').val() === 'true')

                    const resp = await save()
                    numberId = resp.numberId
                    projectId = resp.projectId
                    projectActions = resp.response.projectActions
                    projectForms = resp.response.projectForms
                    sharingLinkRedirectUrl = resp.response.sharingLinkRedirectUrl
                    saving_process = false
                    resolve(resp.response)
                } catch (err) {
                    saving_process = false
                    reject(err)
                }
            })
        })
    }

    /**
     * Публикация проекта
     */
    async function publishProject() {
        try {
            setup({
                apiServer: BASE_URL,
                projectId,
                numberId,
                currentVersionId,
                projectTypeId,
                projectActions,
                projectForms,
                sharingLinkRedirectUrl,
            })

            if (!numberId) {
                await saveProject()
                setup({
                    numberId,
                })
            }

            await createShareEndpoints() // важно: перед saveProject так как меняем здесь данные приложения

            const project = await saveProject()
            await publish()

            return {
                embedCode: getEmbedCode(projectTypeCustomId),
                project,
            }
        } catch (err) {
            throw err
        }
    }

    async function serializeProject(encodeHtml = false) {
        return new Promise(resolve => {
            editedApp.serialize(state => {
                if (encodeHtml) {
                    if (typeof state === 'string') {
                        state = JSON.parse(state)
                    }
                    encodeAllHtmlStringsInObject(state)
                }
                resolve(state)
            })
        })
    }

    async function setEditedProjectPreviewImage(image_id) {
        if (!projectId) {
            await saveProject()
            setup({
                projectId,
            })
        }
        return await setProjectPreviewImage(projectId, image_id)
    }

    function updateScreens(screens) {
        if (screens) {
            store.dispatch(EDITOR__UPDATE_SCREENS(screens))

            ScreenManager.update(
                screens.map(scr => {
                    const groupCfg = getScreenGroup(projectTypeCustomId, { screenTags: scr.tags })
                    if (groupCfg) {
                        return {
                            ...scr,
                            ...groupCfg,
                            id: scr.hashlistId,
                        }
                    }
                    console.error(
                        'Config not found for this screen. Define this screen in editor.config.js (screens/groups). Tags=',
                        scr.tags,
                    )
                }),
            )
        }
    }

    function createControl({ path, value, screenId, componentId, popupId, popupComponentId, screens }) {
        const pconfigs = getPropertyControlConfig(projectTypeCustomId, path, { screens, screenId, popupId })
        if (pconfigs) {
            // we can define many controls for each property
            pconfigs.forEach(pc => {
                if (!createdControls[path] || !createdControls[path].includes(pc)) {
                    // проверить что такой контрол еще не был создан
                    // контрол однозначно задается парой path + конфигурация
                    ControlManager.createControl({
                        ...pc,
                        propertyString: path,
                        value,
                        screenId,
                        componentId,
                        popupId,
                        popupComponentId,
                    })
                    createdControls[path] = createdControls[path] || []
                    createdControls[path].push(pc)
                }
            })
        }
    }

    /**
     * Обработчик событий в приложении
     *
     * @param {string} event
     * @param {object} data
     */
    function onAppChanged(event, data) {
        switch (event) {
            case 'embedded': {
                this.setData({
                    'app.screen': previewMode,
                })

                break
            }
            case 'inited': {
                // screens initial
                if (needShowScreenControl(projectTypeCustomId)) {
                    ScreenManager.init({
                        onScreenEvents: onScreenEvents,
                        projectTypeCustomId,
                        cssUrl: appCssUrl,
                    })
                    updateScreens(data.screens)
                }

                // create initial set of controls
                if (data.initialProperties) {
                    data.initialProperties.forEach(property => createControl({ ...property, screens: data.screens }))
                }

                if (data.screens && data.screens.length > 0) {
                    showScreen(data.screens[0].hashlistId)
                }
                // show first screen by default

                onProductIframeLoaded()
                break
            }
            case 'screens_updated': {
                if (needShowScreenControl(projectTypeCustomId)) {
                    // console.log('Editor: screens_updated');
                    // при любом изменении: добавлении, удалении, изменении порядка - передаем список экранов в контрол. Внутри он сам разберется и перестроит список экранов
                    // это более похоже на React взаимодействие, к которому мы придем в итоге
                    updateScreens(data.screens)
                    // Замечаение: при изменении любого свойства экрана (или компонента на экране) это событие придет дважды
                    // Пример: первый раз изменили фон экрана - это событие вызовется почти мгновенно
                    // И еще через 2-3 сек придет второе такое же событие, так как сгенерируется верстка staticMarkup обновленного экрана.
                    screensRenderedHtmls = {}
                    if (data.screens) {
                        data.screens.forEach(s => (screensRenderedHtmls[s.hashlistId] = s.staticMarkup))
                    }
                }

                break
            }
            case 'properties_updated': {
                // console.log('Editor: properties_updated', data)

                if (data.diff && data.diff.added) {
                    //создать контролы для новых свойств
                    data.diff.added.forEach(property => createControl({ ...property, screens: data.screens }))
                }

                if (data.diff && data.diff.deleted) {
                    //TODO удалить контролы для удаленных свойств
                    // data.diff.deleted.forEach(property => deleteControl(property.path));
                }

                if (data.diff && data.diff.changed) {
                    // current screen changed
                    const sc = data.diff.changed.find(p => p.path === 'router.currentScreenId')
                    if (sc && sc.value !== activeScreen) {
                        showScreen(sc.value, { dontSetAppCurrentScreen: true })
                    }
                }

                break
            }
            case 'selected': {
                if (data) {
                    if (data.doubleClicked) {
                        // сделать текстовый редактор выше на время редактирования
                        Workspace.bringToFront()
                    } else {
                        // data.doubleClicked - режим двойного нажатия (для текстовых компонентов это редактирование текста), не надо показывать окнтролы
                        selectedData = data || null
                        Workspace.selectElementOnAppScreen(data.clientRect) // установить select rect нужно перед ControlManager.filter, так как filter может вызвать показ меню
                        Workspace.setNormalZIndex()
                        ControlManager.filter({ selectedData })
                    }
                    if (data.componentIds.length === 0 || data.dragging) {
                        // компоненты не выделены или в режиме перетаскивания
                        // вернуть фильтры контролов как первоначальному выделению экрана

                        if (store.getState().editor.showPopup) {
                            ControlManager.filter({
                                propertyStrings: null,
                                popupId: store.getState().editor.activePopupId,
                            })
                        } else {
                            ControlManager.filter({
                                screenId: activeScreen,
                                propertyStrings: null,
                            })
                        }
                    }
                }
                break
            }
            case 'request_data_layer': {
                if (data) {
                    callEditor({
                        method: 'request_data_layer',
                        data,
                    })
                }
                break
            }
            case 'request_popup_edit_mode': {
                store.dispatch(EDITOR__UPDATE_ACTIVE_POPUP_ID(data.popupId))
                store.dispatch(EDITOR__SHOW_POPUP())
                editedApp.setData(
                    { [`router.showPopup`]: true, [`router.activePopupId`]: data.popupId },
                    true,
                    true,
                    false,
                )

                break
            }
            case 'request_popups_edit_mode': {
                if (data.enable) {
                    callEditorTab({ method: 'show_popup_slides' })
                    store.dispatch(EDITOR__ENABLE_POPUPS())
                    // ScreenManager.showPopupSlides()
                } else {
                    ScreenManager.hidePopupSlides()
                    callEditorTab({ method: 'hide_popup_slides' })
                    store.dispatch(EDITOR__HIDE_POPUP())
                    store.dispatch(EDITOR__DISABLE_POPUPS())
                    // editedApp.setData({ [`router.showPopup`]: false }, true, true, false)
                }

                break
            }
            // case MutApp.EVENT_PROPERTY_VALUE_CHANGED: {
            //     var ctrls = ControlManager.getControls({propertyString:data.propertyString});
            //     if (ctrls && ctrls.length > 0) {
            //         //TODO разве тут не должен быть for по всем контролам? Контролов же может быть несколько для одного mutAppProperty
            //         ctrls[0].setValue(data.property.getValue());
            //     }
            //     else {
            //         // for example id=pm quiz has no controls, and some hidden properties
            //         //console.error('onAppChanged: there is no control for appProperty: \'' + data.propertyString + '\'');
            //     }

            //     if (data.propertyString === 'appConstructor=mutapp projectPageBackgroundImageUrl') {
            //         // специальное премиум свойство для смены фона проекта
            //         updateProductPageBackgroungImage();
            //     }

            //     if (MutApp.Util.matchPropertyString(data.propertyString, 'appConstructor=mutapp shareEntities.{{id}}.imgUrl') === true) {
            //         // перехватили измемение картинки для шаринга, запрашиваем вычисление ее размеров
            //         // будет произведена запись размеров в скрытые mutAppProperty "appConstructor=mutapp shareEntities.{{id}}.imageWidth"
            //         requestCalculationSizeOfShareImage(data.property.getValue());
            //     }
            //     break;
            // }
        }
    }

    /**
     * надо определить размеры выбранной картинки и записать их в shareEntities,
     * размеры нужны при публикации - поставить их в og теги
     *
     * @param {string} shareImageUrl
     */
    function requestCalculationSizeOfShareImage(shareImageUrl) {
        if (shareImageUrl) {
            var img = new Image()
            img.addEventListener('load', function () {
                console.log('share image: ' + this.naturalWidth + ' ' + this.naturalHeight)
                var app = editedApp
                var shareEntitiesArr = app.shareEntities.toArray()
                for (var i = 0; i < shareEntitiesArr.length; i++) {
                    var e = shareEntitiesArr[i]
                    if (e.imgUrl.getValue() === shareImageUrl) {
                        e.imageWidth = this.naturalWidth
                        e.imageHeight = this.naturalHeight
                        console.log('size has been written')
                    }
                }
            })
            img.src = shareImageUrl
        } else {
            // если урл не задан, то размеры картинки тоже надо сбросить, поставить undefined
            var app = editedApp()
            var shareEntitiesArr = app.shareEntities.toArray()
            for (var i = 0; i < shareEntitiesArr.length; i++) {
                var e = shareEntitiesArr[i]
                if (!e.imgUrl.getValue()) {
                    e.imageWidth = undefined
                    e.imageHeight = undefined
                }
            }
        }
    }

    /**
     * Колбек из workspace о клике по элементу
     *
     * @param {string} event
     * @param {object} data.dataAppPropertyString (can be null to reset selection)
     */
    function onWorkspaceEvents(event, data) {
        // console.log('onWorkspaceEvents: event=' + event + ' dataAppPropertyString=' + data.dataAppPropertyString);
        switch (event) {
            case Workspace.EVENT_CONTROL_POPUP_HIDED: {
                // Так как EVENT_CONTROL_POPUP_HIDED - это событие о скрытии панели popupControlPanel.js внутри Workspace
                // а нам теперь нужно сделать логическое действие - скрыть контрол по правилам. Для этого надо обновить фильтр.
                if (store.getState().editor.showPopup) {
                    ControlManager.filter({
                        propertyStrings: null,
                        popupId: store.getState().editor.activePopupId,
                    })
                } else {
                    ControlManager.filter({
                        propertyStrings: null,
                        screen: editedApp.getScreenById(activeScreen),
                    })
                }

                ControlManager.filter({
                    propertyStrings: null,
                    screen: editedApp.getScreenById(activeScreen),
                })
                break
            }
            case Workspace.EVENT_RESET_SELECTION: {
                // компоненты не выделены
                editedApp.selectComponents([])
                if (store.getState().editor.showPopup) {
                    ControlManager.filter({
                        popupId: store.getState().editor.activePopupId,
                        propertyStrings: null,
                    })
                } else {
                    // вернуть фильтры контролов как первоначальному выделению экрана
                    ControlManager.filter({
                        screenId: activeScreen,
                        propertyStrings: null,
                    })
                }
                Workspace.setNormalZIndex()
                break
            }
            case Workspace.EVENT_SELECT_ELEMENT: {
                // do nothing ?
                break
            }
            case Workspace.EVENT_CONTROL_POPUP_SHOWED: {
                break
            }
            case Workspace.EVENT_QUICK_PANEL_SHOWED: {
                // do nothing
                break
            }
            case Workspace.EVENT_QUICK_PANEL_HIDED: {
                // do nothing
                break
            }
        }
    }

    /**
     * Событие присланное из ControlManager
     *
     * @param {string} event
     * @param {*} data
     */
    function onControlEvents(event, data) {
        data = data || {}
        switch (event) {
            case ControlManager.EVENT_CONTROL_CREATED: {
                // панелька не имеет своего списка контролов и не имеет кобеков на изменения свойств контролов
                // но quickpanel в своем отображении учитывает некоторые свойства контролов. Поэтому передаем ей информацию о создании и изменении
                if (data.control.type === 'quickcontrolpanel') {
                    Workspace.handleQuickControlPropertiesChanged(data.control)
                }
                break
            }
            case ControlManager.EVENT_CONTROL_DELETED: {
                break
            }
            case ControlManager.EVENT_CONTROL_PROPERTIES_CHANGED: {
                if (data.control.type === 'quickcontrolpanel') {
                    Workspace.handleQuickControlPropertiesChanged(data.control)
                }
                break
            }
            case ControlManager.EVENT_QUICK_PANEL_BUTTON_FOR_POPUP_CONTROL_ADDED: {
                // тип data.control.type === popup в данном случае, просто он создал для себя кнопку в quickpanel
                Workspace.handleQuickControlPropertiesChanged(data.control)
                break
            }
            case ControlManager.EVENT_CHANGE_VALUE: {
                editedApp.setData({ [data.propertyString]: data.value })
                break
            }
            case ControlManager.EVENT_FILTER_CHANGED: {
                // {MutApp.Screen} data.screen
                // {Array<string>} data.propertyStrings
                // {boolean} data.quickControlsFiltered
                // {boolean} data.controlPopupFiltered
                if (data.quickControlsFiltered === true) {
                    // был зафильтрован контрол с типом quickcontrolpanel, говорим Workspace показать панель с контролами quickcontrolpanel
                    Workspace.showQuickControlPanel()
                } else {
                    Workspace.hideQuickControlPanel()
                }
                // if (data.controlPopupFiltered === true) {
                //     // был зафильтрован контрол с типом popup, говорим Workspace показать popup контейнер
                //     Workspace.showPopupControlsContainer()
                // } else {
                //     Workspace.hidePopupControlsContainer()
                // }
                break
            }
            case ControlManager.EVENT_HASHLIST_ADD_REQUESTED: {
                if (typeof data.control.prototype === 'function') {
                    editedApp.addHashlistElement(
                        data.control.propertyString,
                        undefined,
                        data.control.prototype(data.control, selectedData),
                    )
                } else if (Array.isArray(data.control.prototype)) {
                    if (data.control.prototype.length > 1) {
                        // требуется участие пользователя чтобы сделать выбор прототипа
                        throw new Error('Editor.onControlEvents(EVENT_HASHLIST_ADD_REQUESTED): not developed yet')
                    } else {
                        editedApp.addHashlistElement(data.control.propertyString, undefined, data.control.prototype[0])
                    }
                } else if (data.control.prototype) {
                    editedApp.addHashlistElement(data.control.propertyString, undefined, data.control.prototype)
                } else {
                    throw new Error('Editor.onControlEvents(EVENT_HASHLIST_ADD_REQUESTED): invalid prototype')
                }
                break
            }
            case ControlManager.EVENT_HASHLIST_CHANGE_POSITION_REQUESTED: {
                const { showPopup, activePopupId } = store.getState().editor
                if (isNumeric(data.elementIndex)) {
                    if (showPopup) {
                        editedApp.changePositionInHashlist(
                            `router.screens.${data.control.screenId}.popups.${activePopupId}.components`,
                            {
                                elementIndex: data.elementIndex,
                                newElementIndex: data.newElementIndex,
                            },
                        )
                    } else {
                        editedApp.changePositionInHashlist(data.control.propertyString, {
                            elementIndex: data.elementIndex,
                            newElementIndex: data.newElementIndex,
                        })
                    }
                } else if (selectedData && selectedData.componentIds && selectedData.componentIds.length === 1) {
                    // допущение: подразумевается что эта операция происходит с выделенными компонентами на экране, то же и с добавлением/удалением
                    if (showPopup) {
                        editedApp.changePositionInHashlist(
                            `router.screens.${data.control.screenId}.popups.${activePopupId}.components`,
                            {
                                elementId: selectedData.componentIds[0],
                                newElementIndex: data.newElementIndex,
                            },
                        )
                    } else {
                        editedApp.changePositionInHashlist(data.control.propertyString, {
                            elementId: selectedData.componentIds[0],
                            newElementIndex: data.newElementIndex,
                        })
                    }
                } else {
                    throw new Error('ControlManager.EVENT_HASHLIST_CHANGE_POSITION_REQUESTED: invalid params')
                }
                break
            }
            case ControlManager.EVENT_HASHLIST_DELETE_REQUESTED: {
                if (selectedData && selectedData.componentIds && selectedData.componentIds.length === 1) {
                    // допущение: подразумевается что эта операция происходит с выделенными компонентами на экране, то же и с добавлением/удалением
                    const { showPopup, activePopupId } = store.getState().editor
                    if (showPopup) {
                        editedApp.deleteHashlistElement(
                            `router.screens.${data.control.screenId}.popups.${activePopupId}.components`,
                            selectedData.componentIds[0],
                        )
                    } else {
                        editedApp.deleteHashlistElement(data.control.propertyString, selectedData.componentIds[0])
                    }
                }
                break
            }
            case ControlManager.EVENT_ASSET_MANAGER_REQUESTED: {
                callEditorTab &&
                    callEditorTab({
                        method: 'assetmanager_select_image',
                        callback: ({ src, srcThumb }) => {
                            editedApp.setData({
                                //TODO add srcThumb
                                [data.propertyString]: src,
                            })
                            if (data.control && data.control.controlName === 'ChooseImage') {
                                data.control._onImageSelected(src)
                            }
                        },
                    })
                break
            }
            case ControlManager.EVENT_DATA_PROVIDER_REQUESTED: {
                callEditorTab &&
                    callEditorTab({
                        method: 'data_provider',
                        data,
                        callback: dataSet => {
                            console.log('[Engage Editor]: Data provider callback ')
                            editedApp.setData({
                                [data.propertyString]: dataSet,
                            })
                        },
                    })
                break
            }
            case ControlManager.EVENT_PROCESS_SELECTED_COMPONENTS: {
                if (selectedData && selectedData.componentIds) {
                    if (typeof data.process !== 'function') {
                        throw new Error(
                            'when call EVENT_PROCESS_SELECTED_COMPONENTS event, you should pass "process" function in data',
                        )
                    }
                    const { showPopup, activePopupId } = store.getState().editor
                    const newProps = data.process({ ...selectedData, showPopup, popupId: activePopupId })
                    editedApp.setData(newProps)
                } else {
                    throw new Error('no selected components but you try to process them, potentially this is a bug')
                }
                break
            }
            default: {
                throw new Error("Editor.onControlEvents: event '" + event + "' is not supported.")
            }
        }
    }

    function showScreenPopups(screenId) {}

    /**
     * Показать экран приложения в редакторе
     * Будут применены фильтрации контролов
     *
     * @param {string} screenId - id экрана в приложении
     * @param {boolean} options.dontSetAppCurrentScreen - не отсылать в приложение информацию об установке экрана
     */
    function showScreen(screenId, options = {}) {
        if (activeScreen !== screenId) {
            if (!options.dontSetAppCurrentScreen) {
                editedApp.setCurrentScreen(screenId)
            }
            activeScreen = screenId
            store.dispatch(EDITOR__UPDATE_ACTIVE_SCREEN_ID(screenId))
            ControlManager.filter({
                screenId: activeScreen,
                propertyStrings: null,
            })
            ScreenManager.showSelectionOnScreen(screenId)
            Workspace.selectElementOnAppScreen(null)
            Workspace.setNormalZIndex()
        }
    }

    /**
     *
     * @param {object} prototype
     * @param {number} position
     */
    function addScreen(prototype, index) {
        // прототипы - это сериализованные копии экранов; Когда сохраняем экран, то сохраняются и id компонентов на экране
        // getElementCopy функция рекурсивно клонирует список компонентов с заменов идентификаторов
        if (!prototype.json) {
            throw new Error('"data" attribute not set for this screen group')
        }
        if (prototype.json.indexOf('adaptedui') < 0) {
            // прототип не содержит информации и моб версии, добавлять его надо в десктоп режиме, иначе этот экран будет принят как мобильный
            changePreviewMode('desktop')
        }
        const newElem = new HashList([JSON.parse(prototype.json)]).getElementCopy(0, {
            cloneChildHashlists: true,
            replaceObjectIds: true,
        })
        editedApp.addHashlistElement('router.screens', index, newElem)
    }

    function addScreenAfter(prototype, beforeScreenId) {
        // прототипы - это сериализованные копии экранов; Когда сохраняем экран, то сохраняются и id компонентов на экране
        // getElementCopy функция рекурсивно клонирует список компонентов с заменов идентификаторов
        if (!prototype.json) {
            throw new Error('"data" attribute not set for this screen group')
        }
        if (prototype.json.indexOf('adaptedui') < 0) {
            // прототип не содержит информации и моб версии, добавлять его надо в десктоп режиме, иначе этот экран будет принят как мобильный
            changePreviewMode('desktop')
        }
        const newElem = new HashList([JSON.parse(prototype.json)]).getElementCopy(0, {
            cloneChildHashlists: true,
            replaceObjectIds: true,
        })
        editedApp.insertAfterHashlistElement('router.screens', beforeScreenId, newElem)
    }

    /**
     * Колбек об изменении в ScreenManager
     *
     * @param {string} event
     * @param {object} data
     */
    function onScreenEvents(event, data) {
        data = data || {}
        switch (event) {
            case ScreenManager.EVENT_SCREEN_SELECT: {
                showScreen(data.screenId)

                editedApp.setData({ ['router.showPopup']: false })
                store.dispatch(EDITOR__HIDE_POPUP())

                break
            }
            case ScreenManager.EVENT_ADD_SCREEN: {
                const groupCfg = getScreenGroup(projectTypeCustomId, { group: data.propertyString })
                const pp = groupCfg.prototypes

                if (!pp || pp.length === 0) {
                    throw new Error(
                        "onScreenEvents.EVENT_ADD_SCREEN: There is no prototypes for screen group '" +
                            data.propertyString +
                            "'",
                    )
                }
                if (pp.length > 1) {
                    // есть несколько прототипов для этой группы экранов, надо открыть окно и дать пользователю выбрать
                    callEditorTab &&
                        callEditorTab({
                            method: 'add_new_slide',
                            data: pp,
                            callback: prototype => {
                                // one prototype was selected and returned
                                addScreenAfter(prototype, data.beforeScreenId)
                            },
                        })
                } else {
                    addScreen(pp[0], data.position)
                }
                break
            }
            case ScreenManager.EVENT_DELETE_SCREEN: {
                editedApp.deleteHashlistElement('router.screens', data.screenId)
                break
            }
            case ScreenManager.EVENT_CHANGE_POSITION: {
                if (isNumeric(data.elementIndex) === false || isNumeric(data.newElementIndex) === false) {
                    throw new Error('onScreenEvents.EVENY_CHANGE_POSITION: invalid params')
                }
                editedApp.changePositionInHashlist('router.screens', {
                    elementId: data.elementHashlistId,
                    delta: data.newElementIndex - data.elementIndex,
                })
                break
            }
            case ScreenManager.EVENT_CLONE_SCREEN: {
                editedApp.cloneHashlistElement('router.screens', data.screenId)
                break
            }
            default:
                return
        }
    }

    function showEditor() {
        $('#id-editor_view').show()
    }

    /**
     * Функция реализующую предпросмотр платной фичи смены фона для страницы.
     * Картинка ставится и в редактировании и в предпросмотре
     */
    // function updateProductPageBackgroungImage() {
    //     // проверка что фича соответствует тарифу
    //     if (Auth.isTariff('basic') === true) {
    //         var ppBackUrl = editedApp.getProperty('appConstructor=mutapp projectPageBackgroundImageUrl').getValue();
    //         $('#id-workspace').css('background-image', (ppBackUrl) ? 'url('+ppBackUrl+')': 'none')
    //             .css('background-repeat','no-repeat')
    //             .css('background-size','cover');
    //         $('#id-preview_background-image').css('background-image', (ppBackUrl) ? 'url('+ppBackUrl+')': 'none')
    //             .css('background-repeat','no-repeat')
    //             .css('background-size','cover');
    //     }
    // }

    /**
     * Перезаписать объекты для шаринга
     */
    async function setShareEntities(entities) {
        editedApp.setShareEntities(entities)
    }

    /**
     * Запросить объекты для шаринга, которые есть в приложении
     */
    async function getShareEntities() {
        return new Promise(resolve => {
            editedApp.getShareEntities(entities => {
                resolve(entities)
            })
        })
    }

    /**
     *  Запросить информацию по распределению Personality
     */
    async function getPersonalityDistribution(links, probabilityOnly, probabilityType) {
        return new Promise(resolve => {
            editedApp.getPersonalityDistribution(links, probabilityOnly, probabilityType, data => {
                resolve(data)
            })
        })
    }

    /**
     *  Запросить информацию по распределению Trivia
     */
    async function getTriviaDistribution() {
        return new Promise(resolve => {
            editedApp.getTriviaDistribution(data => {
                resolve(data)
            })
        })
    }

    function unmount() {
        activeScreen = null

        projectId = null
        numberId = null

        clearInterval(autoSaveInterval)
        window.onbeforeunload = undefined
        createdControls = {}
    }

    /**
     * Возвращает отрисованный канвас по экрану приложения
     *
     * @param {string} screenId
     */
    async function getScreenPreview(screenId) {
        screenId = screenId || Object.keys(screensRenderedHtmls)[0]

        return await getPreview({
            html: screensRenderedHtmls[screenId],
            cssUrl: appCssUrl,
            width: 800,
            height: 600,
        })
    }
    async function getHtmlPreview(html) {
        return await getPreview({
            html,
            width: 1200, // facebook optimal post size
            height: 630,
        })
    }
    function getHtml(screenId) {
        return screensRenderedHtmls[screenId]
    }

    // public methods
    global.start = start
    global.showScreen = showScreen
    global.getResourceManager = function () {
        return resourceManager
    }
    global.getAppId = function () {
        return projectId
    }
    global.getEditedApp = function () {
        return editedApp
    }
    global.getActiveScreen = function () {
        return activeScreen
    }
    global.getAppTemplate = function () {
        return appTemplate
    }
    global.subscribeEditorTopbar = clb => (callEditorTopbar = clb)
    global.subscribeEditorTab = clb => (callEditorTab = clb)
    global.subscribeEditor = clb => (callEditor = clb)
    global.changePreviewMode = changePreviewMode
    global.saveProject = saveProject
    global.publishProject = publishProject
    global.getProjectType = () => projectTypeData
    global.serializeProject = serializeProject
    global.getSharingLinkRedirectUrl = () => sharingLinkRedirectUrl
    global.setSharingLinkRedirectUrl = value => {
        sharingLinkRedirectUrl =
            typeof value === 'string' && value.length ? (value.includes('://') ? value : `//${value}`) : null
    }
    global.getEditedAppSharedOptions = getShareEntities
    global.getEditedAppTriviaDistribution = getTriviaDistribution
    global.getProjectConfig = () => (projectTypeCustomId ? getConfig(projectTypeCustomId) : {})
    global.getEditedAppPersonalityDistribution = async function (
        links = null,
        probabilityOnly = false,
        probabilityType = 'auto',
    ) {
        return await getPersonalityDistribution(links, probabilityOnly, probabilityType)
    }
    global.setEditedAppShareEntities = async function (entities) {
        return setShareEntities(entities)
    }
    global.setEditedProjectPreviewImage = async function (image_id) {
        return await setEditedProjectPreviewImage(image_id)
    }
    global.getEditedAppBoundingClientRect = async () => {
        return new Promise(resolve => {
            editedApp.getAppBoundingClientRect(data => {
                resolve(data)
            })
        })
    }

    global.isUsedDataCollectionFormFeature = () => {
        return !!$('input', 'div.onoffswitch[data-app-property="app.userForm.enable"]').prop('checked')
    }

    global.setEditedAppData = function (propertyString, data) {
        editedApp.setData(
            {
                [propertyString]: data,
            },
            false,
            true,
        )
    }

    global.getScreenPreview = getScreenPreview
    global.getHtmlPreview = getHtmlPreview
    global.getPreviewMode = previewMode

    global.getHtml = getHtml
    global.getAppCssUrl = function () {
        return appCssUrl
    }

    global.unmount = unmount
})(window.Editor)

export default window.Editor
